import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Flex,
  Group,
  Button,
  Text,
  TextInput,
  NumberInput,
  SimpleGrid,
  Paper,
  Select,
  Textarea,
  ScrollArea,
  Radio,
  CheckIcon,
  Loader,
  Switch,
} from "@mantine/core";
import { getAllStatusesList } from "../../../../../services/status";
import { getAllSupplierList } from "../../../../../services/supplier";
import { getAllWarehouseList } from "../../../../../services/warehouse";
import { getAllCityList } from "../../../../../services/location";
import { quantityUnit, bundleUnit } from "../../../../../helper/master-unit";
import { validation } from "../../../../../plugins/validation";
import { useSelector, useDispatch } from "react-redux";
import LoadingData from "../../../../ui/LoadingData";
import { useDebouncedCallback } from "@mantine/hooks";
import { IconTrash } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import { getOrderDetail } from "../../../../../store/orderDetail";
import { getOrderItems } from "../../../../../store/orderItems";
import { updateOrder } from "../../../../../services/orders";
import { calculation } from "../../../../../services/calculation";
import {
  notificationSuccess,
  notificationError,
  loadingNotification,
  completedLoadingNotification,
} from "../../../../ui/Notifications";

const defaultTypeDataPrice = [
  {
    value: "",
    label: "Unknown",
  },
  {
    value: "regular_price",
    label: "Regular Price",
  },
  {
    value: "reseller_price",
    label: "Reseller Price",
  },
  {
    value: "sale_price",
    label: "Sale Price",
  },
  {
    value: "wholesale_price",
    label: "Wholesale Price",
  },
  {
    value: "bulk_price",
    label: "Bundle Price",
  },
];

const defaultVal = {
  product_name: "",
  original_name: "",
  original_source_url: "",
  city_id: null,
  supplier_id: null,
  warehouse_id: null,
  original_price: null,
  original_price_type: "",
  detail_id: null,
  quantity: null,
  unit_name: "",
  quantity_per_unit: null,
  base_unit_name: "",
  // price: _item.price, (rule of BE,. whatever happen dont send filed price)
  origin_sku: "",
  ali_sku: "",
  landed_cost: null,
  revised_landed_cost: null,
  revised_quantity: null,
  commission_per_sku: null,
  cost: null,
  sku_status: {
    id: null,
  },
  rule: {
    vw_width: null,
    vw_height: null,
    vw_length: null,
    vw_dimension_unit: "",
    weight: null,
    weight_unit: "",
    total_weight: null,
    total_tax: 0,
    qty_cbm: "",
    cbm_per_unit: null,
    hscodes: null,
    taxes: [
      {
        label: "BM",
        value: null,
      },
      {
        label: "PPH",
        value: null,
      },
      {
        label: "PPN",
        value: null,
      },
    ],
  },
  note: "",
  variants: [],
};

const defaultFormTaxes = {
  bm: null,
  ppn: null,
  pph: null,
};

const formValidation = {
  product_name: {
    isError: false,
    message: "",
  },
  original_name: {
    isError: false,
    message: "",
  },
  original_source_url: {
    isError: false,
    message: "",
  },
  cost: {
    isError: false,
    message: "",
  },
  original_price: {
    isError: false,
    message: "",
  },
  unit_name: {
    isError: false,
    message: "",
  },
  quantity: {
    isError: false,
    message: "",
  },
  base_unit_name: {
    isError: false,
    message: "",
  },
  quantity_per_unit: {
    isError: false,
    message: "",
  },
  width: {
    isError: false,
    message: "",
  },
  height: {
    isError: false,
    message: "",
  },
  length: {
    isError: false,
    message: "",
  },
  weight: {
    isError: false,
    message: "",
  },
  bm: {
    isError: false,
    message: "",
  },
  ppn: {
    isError: false,
    message: "",
  },
  pph: {
    isError: false,
    message: "",
  },
};

const variantValidation = {
  name: {
    isError: false,
    message: "",
  },
  option: {
    isError: false,
    message: "",
  },
};

const FormAdjustOrderProduct = ({ detailItem, onCloseModal }) => {
  const { summary } = useSelector((state) => state.order_detail);
  const dispatch = useDispatch();
  const params = useParams();
  const orderId = params.order_id;
  const [formData, setFormData] = useState(defaultVal);
  const [formTaxes, setFormTaxes] = useState(defaultFormTaxes);
  const [validationForm, setValidationForm] = useState(formValidation);
  const [validationVariant, setValidationVariant] = useState(variantValidation);
  const [loadingForm, setLoadingForm] = useState(false);
  const [selectedTab, setSelectedTab] = useState("order");
  const [loadingStatus, setLoadingStatus] = useState(true);
  const [statusOrderList, setStatusOrderList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [loadingSupplier, setLoadingSupplier] = useState(true);
  const [searchSupplier, setSearchSupplier] = useState("");
  const [warehouseList, setWarehouseList] = useState([]);
  const [loadingWarehouse, setLoadingWarehouse] = useState(true);
  const [searchWarehouse, setSearchWarehouse] = useState("");
  const [cityList, setCityList] = useState([]);
  const [loadingCity, setLoadingCity] = useState(true);
  const [searchCity, setSearchCity] = useState("");
  const [useVariant, setUseVariant] = useState(false);

  const submitUpdateOrderItem = async (form, formTax) => {
    setLoadingForm(true);
    setValidationForm(formValidation);
    setValidationVariant(variantValidation);
    const validateForm = {
      product_name: form.product_name,
      original_name: form.original_name,
      original_source_url: form.original_source_url,
      original_price: `${form.original_price}`,
      cost: `${form.cost}`,
      unit_name: form.unit_name,
      quantity: `${form.quantity}`,
      base_unit_name: form.base_unit_name,
      quantity_per_unit: `${form.quantity_per_unit}`,
      width: `${form.rule.vw_width}`,
      height: `${form.rule.vw_height}`,
      length: `${form.rule.vw_length}`,
      weight: `${form.rule.weight}`,
      bm: `${formTax.bm}`,
      ppn: `${formTax.ppn}`,
      pph: `${formTax.pph}`,
    };
    if (!form.original_price_type !== "bulk_price") {
      delete validateForm.base_unit_name;
      delete validateForm.quantity_per_unit;
    }
    const isErrorForm = validation(validateForm, setValidationForm);
    if (isErrorForm) {
      notificationError("Update Order Item Error", "Check recheck your form");
      setLoadingForm(false);
      return;
    }
    if (useVariant) {
      const variantProduct = form.variants;
      if (variantProduct.length > 0) {
        let validateVariant = {};

        for (let i = 0; i < variantProduct.length; i++) {
          validateVariant = {
            name: variantProduct[i].name,
            option: variantProduct[i].option,
          };
        }
        const isErrorVariant = validation(
          validateVariant,
          setValidationVariant,
        );
        if (isErrorVariant) {
          setSelectedTab("variant");
          notificationError(
            "Update Order Item Error",
            "Check recheck your form variant",
          );
          setLoadingForm(false);
          return;
        }
      } else {
        setSelectedTab("variant");
        notificationError(
          "Update Order Item Error",
          "Please add value in variant",
        );
        setLoadingForm(false);
        return;
      }
    }

    const payload = {
      items: [],
    };

    const handleSetVariant = (useVariant, dataProduct, dataVariant) => {
      let data = [];
      if (useVariant) {
        data = dataVariant;
      } else {
        const hasRealVariants =
          dataVariant &&
          dataVariant.length > 0 &&
          dataVariant[0].name !== "Product Name";
        if (hasRealVariants) {
          data = dataVariant;
        } else {
          data.push({
            name: "Product Name",
            option: dataProduct.product_name,
          });
        }
      }
      return data;
    };

    const updateItem = {
      ...form,
      rule: {
        ...form.rule,
        taxes: [
          {
            label: "BM",
            value: formTax.bm,
          },
          {
            label: "PPH",
            value: formTax.pph,
          },
          {
            label: "PPN",
            value: formTax.ppn,
          },
        ],
      },
      variants: handleSetVariant(useVariant, form, form.variants),
    };

    payload.items.push(updateItem);
    try {
      const response = await updateOrder(orderId, payload);
      if (response.success) {
        const loadingCalculation = loadingNotification(
          "Waiting Calculation Order",
          "Please Wait. . .",
        );
        const responseCalculation = await calculation(orderId);
        if (responseCalculation.success) {
          dispatch(getOrderDetail(orderId));
          dispatch(getOrderItems(orderId));
          completedLoadingNotification(
            loadingCalculation,
            "Calculation Order Successfully",
            "This order has been completed in calculation",
          );
          notificationSuccess(
            "Update Order Items Completed",
            "You have been updated data items",
          );
          onCloseModal();
        }
      }
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.message;
      notificationError(
        "Update Order Error",
        `${errorMessage ? errorMessage : "Please contact your administrator"}`,
      );
    } finally {
      setLoadingForm(false);
    }
  };

  const handleGetListSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSupplier(true);
    const parameter = {
      "filter[id][is]": supplierId,
      "filter[name][like]": searchSupplier,
      "page[num]": 1,
      "page[limit]": 10, // bad habbit
      "fields[supplier]": "name",
    };

    try {
      const response = await getAllSupplierList(parameter);
      const dataSuppliers = response.data;
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        };
      });
      setSupplierList(remapDataSuppliers);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSupplier(false);
    }
  }, 300);

  const handleGetListWarehouse = useDebouncedCallback(async (warehouseId) => {
    setLoadingWarehouse(true);
    const parameter = {
      "filter[id][is]": warehouseId,
      "filter[name][like]": searchWarehouse,
      "page[num]": 1,
      "page[limit]": 10, // bad habbit
    };

    try {
      const response = await getAllWarehouseList(parameter);
      const dataWarehouse = response.data;
      const remapDataWarehouse = dataWarehouse.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        };
      });
      setWarehouseList(remapDataWarehouse);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingWarehouse(false);
    }
  }, 300);

  const handleGetListCity = useDebouncedCallback(async (cityId) => {
    setLoadingCity(true);
    const parameter = {
      "filter[id][is]": cityId,
      "filter[name][like]": searchCity,
      "page[num]": 1,
      "page[limit]": 10, // bad habbit
    };

    try {
      const response = await getAllCityList(parameter);
      const dataCity = response.data;
      const remapDataCity = dataCity.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        };
      });
      setCityList(remapDataCity);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingCity(false);
    }
  }, 300);

  const handleGetOrderStatusList = async () => {
    setLoadingStatus(true);
    const params = {
      "filter[status_type][is]": 4,
    };
    try {
      const response = await getAllStatusesList(params);
      const responseData = response.data;
      const remapStatus = responseData.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label:
            val.attributes.name.charAt(0).toUpperCase() +
            val.attributes.name.slice(1),
        };
      });
      setStatusOrderList(remapStatus);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingStatus(false);
    }
  };

  useEffect(() => {
    handleGetListSupplier();
    // eslint-disable-next-line
  }, [searchSupplier]);

  useEffect(() => {
    handleGetListWarehouse();
    // eslint-disable-next-line
  }, [searchWarehouse]);

  useEffect(() => {
    handleGetListCity();
    // eslint-disable-next-line
  }, [searchCity]);

  useEffect(() => {
    if (selectedTab === "sku") {
      handleGetOrderStatusList();
    }
  }, [selectedTab]);

  useEffect(() => {
    if (detailItem) {
      if (detailItem.supplierId) {
        handleGetListSupplier(detailItem.supplierId);
      }
      if (detailItem.warehouse_id) {
        handleGetListWarehouse(detailItem.warehouse_id);
      }
      if (detailItem.cityId) {
        handleGetListCity(detailItem.cityId);
      }
      handleSetForm(detailItem);
    }
    // eslint-disable-next-line
  }, [detailItem]);

  useEffect(() => {
    if (formData.original_price_type === "bulk_price") {
      setUseVariant(false);
    }
    if (formData.original_price_type) {
      handleChangeForm(
        "unit_name",
        formData.original_price_type === "bulk_price" ? "crt" : "pcs",
      );
    }
    // eslint-disable-next-line
  }, [formData.original_price_type]);

  useEffect(() => {
    if (useVariant) {
      handleChangeForm("original_price_type", "");
    }
  }, [useVariant]);

  const handleSetForm = (val) => {
    const recentValue = {
      product_name: val.productName,
      original_name: val.originalName,
      original_source_url: val.originalSourceUrl,
      city_id: val.cityId,
      city_name: val.cityName,
      supplier_id: val.supplierId,
      warehouse_id: val.warehouse_id,
      original_price: val.originalPrice,
      original_price_type: val.originalPriceType ? val.originalPriceType : "",
      detail_id: val.id,
      quantity: val.quantity,
      unit_name: val.unit_name,
      quantity_per_unit: val.quantity_per_unit,
      base_unit_name: val.base_unit_name,
      // price: val.price, (rule of BE,. whatever happen dont send filed price)
      origin_sku: val.originalSku,
      ali_sku: val.aliSku,
      landed_cost: val.landed_cost,
      revised_landed_cost: val.revised_landed_cost,
      revised_quantity: val.revised_quantity,
      commission_per_sku: val.commission_per_sku,
      cost: val.price,
      sku_status: {
        id: `${val.skuStatus[0].id}`,
      },
      rule: {
        vw_width: val.vwWidth,
        vw_height: val.vwHeight,
        vw_length: val.vwLength,
        vw_dimension_unit: val.vwDimensionUnit,
        weight: val.weight,
        weight_unit: val.weightUnit,
        total_weight: val.weight,
        total_tax: 0,
        qty_cbm: val.cbm,
        cbm_per_unit: val.cbmPerUnit,
        hscodes: val.hscodes,
        taxes: [
          {
            label: "BM",
            value: val.bm,
          },
          {
            label: "PPH",
            value: val.pph,
          },
          {
            label: "PPN",
            value: val.ppn,
          },
        ],
      },
      note: val.adminNote,
      variants: val.variants || [],
    };
    const recentTax = {
      bm: val.bm,
      pph: val.pph,
      ppn: val.ppn,
    };
    setFormData(recentValue);
    setFormTaxes(recentTax);
    const hasRealVariants =
      val.variants &&
      val.variants.length > 0 &&
      val.variants[0].name !== "Product Name";
    setUseVariant(hasRealVariants);
  };

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val }));
  };

  const handleChangeTax = (name, val) => {
    setFormTaxes((oldVal) => ({ ...oldVal, [name]: val }));
  };

  const handleChangeRule = (name, val) => {
    setFormData((oldVal) => ({
      ...oldVal,
      rule: {
        ...oldVal.rule,
        [name]: val,
      },
    }));
  };

  const convertToMeters = (value, unit) => {
    if (!value || !unit) return 0;
    const num = Number(value);
    switch (unit) {
      case "m":
        return num;
      case "cm":
        return num / 100;
      case "ft":
        return num * 0.3048;
      case "inch":
        return num * 0.0254;
      default:
        return num;
    }
  };

  useEffect(() => {
    const { vw_width, vw_height, vw_length, vw_dimension_unit } = formData.rule;
    if (vw_width && vw_height && vw_length && vw_dimension_unit) {
      const w = convertToMeters(vw_width, vw_dimension_unit);
      const h = convertToMeters(vw_height, vw_dimension_unit);
      const l = convertToMeters(vw_length, vw_dimension_unit);
      const cbm = Number((w * h * l).toFixed(4));
      handleChangeRule("cbm_per_unit", cbm);
    }
    // eslint-disable-next-line
  }, [formData.rule.vw_width, formData.rule.vw_height, formData.rule.vw_length, formData.rule.vw_dimension_unit]);

  const handleChangeStatus = (val) => {
    setFormData((oldVal) => ({
      ...oldVal,
      sku_status: {
        id: val,
      },
    }));
  };

  const handleAddVariant = () => {
    setValidationVariant(variantValidation);
    const dataVariant = formData.variants;
    const payloadVariant = {
      name: "",
      option: "",
    };
    dataVariant.push(payloadVariant);
    setFormData((oldVal) => ({ ...oldVal, variants: dataVariant }));
  };

  const handleRemoveVariant = (indexVariant) => {
    setValidationVariant(variantValidation);
    const dataVariant = [...formData.variants];
    dataVariant.splice(indexVariant, 1);
    setFormData((oldVal) => ({ ...oldVal, variants: dataVariant }));
  };

  const handleChangeVariant = (indexVariant, labelName, value) => {
    const formVariant = formData.variants;
    const remapForm = formVariant.map((val, index) => {
      if (index === indexVariant) {
        return {
          ...val,
          [labelName]: value,
        };
      } else {
        return val;
      }
    });
    setFormData((oldVal) => ({ ...oldVal, variants: remapForm }));
  };

  const loadingDataTemplate = () => {
    return (
      <Box ta="center" my={12}>
        <Loader size={16} />
        <Text c="gray.6" fz={11}>
          Loading Data
        </Text>
      </Box>
    );
  };

  const loadForm = () => {
    const mappingFormBundleUnit = (typePrice) => {
      if (typePrice !== "bulk_price") {
        return (
          <SimpleGrid cols={3} verticalSpacing="sm" mb="sm">
            <Box>
              <Select
                name="unit_name"
                value={formData.unit_name}
                label="Unit Name"
                placeholder="Select unit name"
                data={quantityUnit}
                onChange={(val) => handleChangeForm("unit_name", val)}
                error={
                  validationForm.unit_name.isError
                    ? `${validationForm.unit_name.message}`
                    : ""
                }
                size="xs"
                withAsterisk
                allowDeselect={false}
              />
            </Box>
            <Box>
              <NumberInput
                name="quantity"
                label="Quantity"
                value={formData.quantity}
                rightSection={
                  <Text fz="xs" c="black" tt="capitalize">
                    {formData.unit_name}
                  </Text>
                }
                placeholder="Input quantity"
                onChange={(val) => handleChangeForm("quantity", val)}
                error={
                  validationForm.quantity.isError
                    ? `${validationForm.quantity.message}`
                    : ""
                }
                size="xs"
                withAsterisk
                rightSectionWidth={40}
              />
            </Box>
            <Box>
              <NumberInput
                name="revised_quantity"
                label="Revised Quantity"
                value={formData.revised_quantity}
                rightSection={
                  <Text fz="xs" c="black" tt="capitalize">
                    {formData.revised_quantity}
                  </Text>
                }
                placeholder="Input revised_quantity"
                onChange={(val) => handleChangeForm("revised_quantity", val)}
                size="xs"
                rightSectionWidth={40}
              />
            </Box>
          </SimpleGrid>
        );
      } else {
        return (
          <Box>
            <SimpleGrid cols={3} verticalSpacing="sm" mb="sm">
              <Box>
                <Select
                  name="unit_name"
                  value={formData.unit_name}
                  label="Unit Name"
                  placeholder="Select unit name"
                  data={bundleUnit}
                  onChange={(val) => handleChangeForm("unit_name", val)}
                  error={
                    validationForm.unit_name.isError
                      ? `${validationForm.unit_name.message}`
                      : ""
                  }
                  size="xs"
                  withAsterisk
                  allowDeselect={false}
                />
              </Box>
              <Box>
                <NumberInput
                  name="quantity"
                  label="Quantity"
                  value={formData.quantity}
                  rightSection={
                    <Text fz="xs" c="black" tt="capitalize">
                      {formData.unit_name}
                    </Text>
                  }
                  placeholder="Input quantity"
                  onChange={(val) => handleChangeForm("quantity", val)}
                  error={
                    validationForm.quantity.isError
                      ? `${validationForm.quantity.message}`
                      : ""
                  }
                  size="xs"
                  withAsterisk
                  rightSectionWidth={40}
                />
              </Box>
              <Box>
                <NumberInput
                  name="revised_quantity"
                  label="Revised Quantity"
                  value={formData.revised_quantity}
                  rightSection={
                    <Text fz="xs" c="black" tt="capitalize">
                      {formData.unit_name}
                    </Text>
                  }
                  placeholder="Input revised_quantity"
                  onChange={(val) => handleChangeForm("revised_quantity", val)}
                  size="xs"
                  rightSectionWidth={40}
                />
              </Box>
            </SimpleGrid>
            <Text fz={16} fw="bold" my={10}>
              Bundle Information
            </Text>
            <SimpleGrid cols={2} verticalSpacing="sm" mb="sm">
              <Box>
                <Select
                  name="base_unit_name"
                  value={formData.base_unit_name}
                  label="Base Unit Name"
                  placeholder="Select base unit name"
                  data={quantityUnit}
                  onChange={(val) => handleChangeForm("base_unit_name", val)}
                  error={
                    validationForm.base_unit_name.isError
                      ? `${validationForm.base_unit_name.message}`
                      : ""
                  }
                  size="xs"
                  withAsterisk
                  allowDeselect={false}
                />
              </Box>
              <Box>
                <NumberInput
                  name="quantity_per_unit"
                  label="Quantity Per Unit"
                  value={formData.quantity_per_unit}
                  rightSection={
                    <Text fz="xs" c="black" tt="capitalize">
                      {formData.unit_name}
                    </Text>
                  }
                  placeholder="Input quantity per unit"
                  onChange={(val) => handleChangeForm("quantity_per_unit", val)}
                  error={
                    validationForm.quantity_per_unit.isError
                      ? `${validationForm.quantity_per_unit.message}`
                      : ""
                  }
                  size="xs"
                  withAsterisk
                  rightSectionWidth={40}
                />
              </Box>
            </SimpleGrid>
            <Text fz={13} my={8} c="red">
              <Text span fw="bold" inherit>
                Note:{" "}
              </Text>{" "}
              Bundle Information : 1 {formData.unit_name} ={" "}
              <Text span fw="bold" inherit>
                {formData.quantity_per_unit} {formData.base_unit_name}
              </Text>
            </Text>
          </Box>
        );
      }
    };

    const loadDataStatus = () => {
      const mappingDataStatus = (data) => {
        const remapStatus = data.map((val, index) => {
          return (
            <Paper
              shadow="xs"
              radius="md"
              withBorder
              p="md"
              key={index}
              mb={12}
            >
              <Radio
                size="sm"
                icon={CheckIcon}
                value={val.value}
                label={
                  <Text fz={12} fw="500" tt="capitalize" c="gray.7">
                    {val.label}
                  </Text>
                }
              />
            </Paper>
          );
        });
        return remapStatus;
      };

      return (
        <Box my={20}>
          <Radio.Group
            value={formData.sku_status.id}
            onChange={(val) => handleChangeStatus(val)}
            name="sku_status.id"
            icon={CheckIcon}
            withAsterisk
            size="xs"
          >
            {mappingDataStatus(statusOrderList)}
          </Radio.Group>
        </Box>
      );
    };

    const mappingFormVariant = (useVariant) => {
      if (useVariant) {
        const showFormVariant = () => {
          const variantProduct = formData.variants;
          const remapVariant = variantProduct.map((val, index) => {
            return (
              <Box key={index} mb={8}>
                <SimpleGrid cols={2} verticalSpacing="md" spacing="xs">
                  <Box>
                    <TextInput
                      value={variantProduct[index].name}
                      label={`Variant Option ${index + 1}`}
                      placeholder="Example: Color, Size, Storage"
                      onChange={(val) =>
                        handleChangeVariant(index, `name`, val.target.value)
                      }
                      error={
                        validationVariant.name.isError
                          ? `${validationVariant.name.message}`
                          : ""
                      }
                      withAsterisk
                      size="xs"
                    />
                  </Box>
                  <Box>
                    <TextInput
                      value={variantProduct[index].option}
                      label={`Variant Option Value ${index + 1}`}
                      placeholder="Example: Red, Green, Blue, Small, Medium"
                      onChange={(val) =>
                        handleChangeVariant(index, `option`, val.target.value)
                      }
                      error={
                        validationVariant.option.isError
                          ? `${validationVariant.option.message}`
                          : ""
                      }
                      withAsterisk
                      size="xs"
                    />
                  </Box>
                </SimpleGrid>
                <Box mt={8} h={30}>
                  <Button
                    size="compact-xs"
                    variant="outline"
                    leftSection={<IconTrash size={12} />}
                    onClick={() => handleRemoveVariant(index)}
                  >
                    Remove Variant
                  </Button>
                </Box>
              </Box>
            );
          });
          return remapVariant;
        };

        return (
          <Box mb="md">
            <Flex justify="space-between" align="center" mb={14}>
              <Text fz={16} fw="bold" mb={14}>
                Variant
              </Text>
              <Button
                size="xs"
                onClick={() => handleAddVariant()}
                disabled={formData.variants.length > 2}
              >
                Add Variant
              </Button>
            </Flex>
            <Box my={10}>{showFormVariant()}</Box>
          </Box>
        );
      }
    };

    return (
      <Box>
        <Box>
          <Tabs
            variant="pills"
            radius="lg"
            defaultValue="order"
            value={selectedTab}
            onChange={setSelectedTab}
          >
            <Tabs.List>
              <Tabs.Tab value="order">Order</Tabs.Tab>
              <Tabs.Tab value="sku">SKU Status</Tabs.Tab>
              <Tabs.Tab value="spesification">Spesification</Tabs.Tab>
              <Tabs.Tab value="tax">Tax</Tabs.Tab>
              <Tabs.Tab value="variant">Variant</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="order">
              <ScrollArea
                h={500}
                type="scroll"
                offsetScrollbars
                scrollbarSize={4}
                py={20}
              >
                <Box mb={20}>
                  <Text fz={16} fw="bold" mb={10}>
                    General Info
                  </Text>
                  <Box mb="sm">
                    <TextInput
                      name="product_name"
                      value={formData.product_name}
                      label="Product Title"
                      placeholder="Input product title"
                      onChange={(val) =>
                        handleChangeForm("product_name", val.target.value)
                      }
                      error={
                        validationForm.product_name.isError
                          ? `${validationForm.product_name.message}`
                          : ""
                      }
                      withAsterisk
                      size="xs"
                    />
                  </Box>
                  <Box mb="sm">
                    <TextInput
                      name="original_name"
                      value={formData.original_name}
                      label="Original Title"
                      placeholder="Input original title"
                      onChange={(val) =>
                        handleChangeForm("original_name", val.target.value)
                      }
                      error={
                        validationForm.original_name.isError
                          ? `${validationForm.original_name.message}`
                          : ""
                      }
                      withAsterisk
                      size="xs"
                    />
                  </Box>
                  <Box mb="sm">
                    <TextInput
                      name="original_source_url"
                      value={formData.original_source_url}
                      label="Original Source URL"
                      placeholder="Input original source URL"
                      onChange={(val) =>
                        handleChangeForm(
                          "original_source_url",
                          val.target.value,
                        )
                      }
                      error={
                        validationForm.original_source_url.isError
                          ? `${validationForm.original_source_url.message}`
                          : ""
                      }
                      withAsterisk
                      size="xs"
                    />
                  </Box>
                  <SimpleGrid cols={2} verticalSpacing="sm" mb="md">
                    <Box>
                      <NumberInput
                        label="Price"
                        placeholder="Input price"
                        value={formData.cost}
                        leftSection={
                          <Text fz={12} c="black" tt="capitalize">
                            {summary.orderCurrency}
                          </Text>
                        }
                        leftSectionWidth={40}
                        onChange={(val) => handleChangeForm("cost", val)}
                        error={
                          validationForm.cost.isError
                            ? `${validationForm.cost.message}`
                            : ""
                        }
                        thousandSeparator=","
                        size="xs"
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label="Original Price"
                        placeholder="Input original price"
                        value={formData.original_price}
                        leftSection={
                          <Text fz={12} c="black" tt="capitalize">
                            {summary.goodsCurrency}
                          </Text>
                        }
                        leftSectionWidth={40}
                        onChange={(val) =>
                          handleChangeForm("original_price", val)
                        }
                        error={
                          validationForm.original_price.isError
                            ? `${validationForm.original_price.message}`
                            : ""
                        }
                        thousandSeparator=","
                        size="xs"
                        withAsterisk
                      />
                    </Box>
                  </SimpleGrid>
                  <Paper
                    shadow="xs"
                    radius="xs"
                    withBorder
                    p="md"
                    my="sm"
                    style={{ borderStyle: "dashed" }}
                  >
                    <Box mb="sm">
                      <Select
                        name="original_price_type"
                        value={formData.original_price_type}
                        label="Price Type"
                        data={defaultTypeDataPrice}
                        onChange={(val) =>
                          handleChangeForm("original_price_type", val)
                        }
                        size="xs"
                        allowDeselect={false}
                      />
                    </Box>
                    {mappingFormBundleUnit(formData.original_price_type)}
                  </Paper>
                </Box>
                <Box>
                  <Text fz={16} fw="bold" my={10}>
                    Dimension, Weight & CBM
                  </Text>
                  <Box>
                    <SimpleGrid cols={3} verticalSpacing="sm" mb="sm">
                      <Box>
                        <NumberInput
                          label="Width"
                          placeholder="Input width"
                          value={formData.rule.vw_width}
                          rightSection={
                            <Text fz={12} c="black">
                              {formData.rule.vw_dimension_unit}
                            </Text>
                          }
                          rightSectionWidth={40}
                          onChange={(val) => handleChangeRule("vw_width", val)}
                          error={
                            validationForm.width.isError
                              ? `${validationForm.width.message}`
                              : ""
                          }
                          thousandSeparator=","
                          size="xs"
                          withAsterisk
                        />
                      </Box>
                      <Box>
                        <NumberInput
                          label="Height"
                          placeholder="Input height"
                          value={formData.rule.vw_height}
                          rightSection={
                            <Text fz={12} c="black">
                              {formData.rule.vw_dimension_unit}
                            </Text>
                          }
                          rightSectionWidth={40}
                          onChange={(val) => handleChangeRule("vw_height", val)}
                          error={
                            validationForm.height.isError
                              ? `${validationForm.height.message}`
                              : ""
                          }
                          thousandSeparator=","
                          size="xs"
                          withAsterisk
                        />
                      </Box>
                      <Box>
                        <NumberInput
                          label="Length"
                          placeholder="Input length"
                          value={formData.rule.vw_length}
                          rightSection={
                            <Text fz={12} c="black">
                              {formData.rule.vw_dimension_unit}
                            </Text>
                          }
                          rightSectionWidth={40}
                          onChange={(val) => handleChangeRule("vw_length", val)}
                          error={
                            validationForm.length.isError
                              ? `${validationForm.length.message}`
                              : ""
                          }
                          thousandSeparator=","
                          size="xs"
                          withAsterisk
                        />
                      </Box>
                      <Box>
                        <NumberInput
                          label={`Weight / ${formData.unit_name}`}
                          placeholder="Input weight"
                          value={formData.rule.weight}
                          rightSection={
                            <Text fz={12} c="black">
                              {formData.rule.weight_unit}
                            </Text>
                          }
                          rightSectionWidth={40}
                          onChange={(val) => handleChangeRule("weight", val)}
                          error={
                            validationForm.weight.isError
                              ? `${validationForm.weight.message}`
                              : ""
                          }
                          thousandSeparator=","
                          size="xs"
                          withAsterisk
                        />
                      </Box>
                      <Box>
                        <NumberInput
                          label={`Cbm / ${formData.unit_name} (Auto Calculate)`}
                          value={formData.rule.cbm_per_unit}
                          rightSection={
                            <Text fz={12} c="black">
                              m³
                            </Text>
                          }
                          rightSectionWidth={40}
                          disabled
                          thousandSeparator=","
                          size="xs"
                        />
                      </Box>
                    </SimpleGrid>
                    <SimpleGrid cols={2} verticalSpacing="sm" mb="sm">
                      <Box>
                        <NumberInput
                          label={`Landed Cost / ${formData.unit_name} (Auto Calculate)`}
                          value={formData.landed_cost}
                          leftSection={
                            <Text fz={12} c="black" tt="capitalize">
                              {summary.orderCurrency}
                            </Text>
                          }
                          leftSectionWidth={40}
                          thousandSeparator=","
                          size="xs"
                          disabled
                        />
                      </Box>
                      <Box>
                        <NumberInput
                          label={`Revised Landed Cost / ${formData.unit_name}`}
                          placeholder="Input revised landed cost"
                          value={formData.revised_landed_cost}
                          leftSection={
                            <Text fz={12} c="black" tt="capitalize">
                              {summary.orderCurrency}
                            </Text>
                          }
                          leftSectionWidth={40}
                          onChange={(val) =>
                            handleChangeForm("revised_landed_cost", val)
                          }
                          thousandSeparator=","
                          size="xs"
                        />
                      </Box>
                    </SimpleGrid>
                    <Box mb="md">
                      <Textarea
                        name="note"
                        label="Admin Note"
                        placeholder="Input note"
                        value={formData.note}
                        onChange={(val) =>
                          handleChangeForm("note", val.target.value)
                        }
                        size="xs"
                        autosize
                        minRows={4}
                        maxRows={4}
                      />
                    </Box>
                  </Box>
                </Box>
              </ScrollArea>
            </Tabs.Panel>
            <Tabs.Panel value="sku">
              {loadingStatus ? <LoadingData /> : loadDataStatus()}
            </Tabs.Panel>
            <Tabs.Panel value="spesification">
              <ScrollArea
                h={500}
                type="scroll"
                offsetScrollbars
                scrollbarSize={4}
                py={20}
              >
                <Box>
                  <SimpleGrid cols={2} verticalSpacing="sm" mb="sm">
                    <Box>
                      <TextInput
                        name="origin_sku"
                        value={formData.origin_sku}
                        label="Original SKU"
                        placeholder="Input original SKU"
                        onChange={(val) =>
                          handleChangeForm("origin_sku", val.target.value)
                        }
                        size="xs"
                      />
                    </Box>
                    <Box>
                      <TextInput
                        name="ali_sku"
                        value={formData.ali_sku}
                        label="ALI SKU"
                        placeholder="Input ALI SKU"
                        onChange={(val) =>
                          handleChangeForm("ali_sku", val.target.value)
                        }
                        size="xs"
                      />
                    </Box>
                  </SimpleGrid>
                  <Box mb="sm">
                    <Select
                      name="supplier_id"
                      label="Supplier"
                      value={formData.supplier_id}
                      data={supplierList}
                      onChange={(val) => handleChangeForm("supplier_id", val)}
                      size="xs"
                      searchable
                      searchValue={searchSupplier}
                      onSearchChange={setSearchSupplier}
                      nothingFoundMessage={
                        !loadingSupplier
                          ? supplierList.length > 0
                            ? ""
                            : "No Supplier Found"
                          : loadingDataTemplate()
                      }
                      clearable
                    />
                  </Box>
                  <Box mb="sm">
                    <Select
                      name="warehouse_id"
                      label="Warehouse"
                      value={formData.warehouse_id}
                      data={warehouseList}
                      onChange={(val) => handleChangeForm("warehouse_id", val)}
                      size="xs"
                      searchable
                      searchValue={searchWarehouse}
                      onSearchChange={setSearchWarehouse}
                      nothingFoundMessage={
                        !loadingWarehouse
                          ? warehouseList.length > 0
                            ? ""
                            : "No Warehouse Found"
                          : loadingDataTemplate()
                      }
                      clearable
                    />
                  </Box>
                  <Box mb="sm">
                    <Select
                      name="city_id"
                      label="City"
                      value={formData.city_id}
                      data={cityList}
                      onChange={(val) => handleChangeForm("city_id", val)}
                      size="xs"
                      searchable
                      searchValue={searchCity}
                      onSearchChange={setSearchCity}
                      nothingFoundMessage={
                        !loadingCity
                          ? cityList.length > 0
                            ? ""
                            : "No City Found"
                          : loadingDataTemplate()
                      }
                      clearable
                    />
                  </Box>
                </Box>
              </ScrollArea>
            </Tabs.Panel>
            <Tabs.Panel value="tax">
              <ScrollArea
                h={500}
                type="scroll"
                offsetScrollbars
                scrollbarSize={4}
                py={20}
              >
                <Box>
                  <Box mb="sm">
                    <TextInput
                      name="hscodes"
                      value={formData.rule.hscodes}
                      label="Hscodes"
                      placeholder="Input hscodes"
                      onChange={(val) =>
                        handleChangeRule("hscodes", val.target.value)
                      }
                      size="xs"
                    />
                  </Box>
                  <SimpleGrid cols={3} verticalSpacing="sm" mb="sm">
                    <Box>
                      <NumberInput
                        label="BM / Duty"
                        placeholder="Input bm"
                        value={formTaxes.bm}
                        rightSection={
                          <Text fz={12} c="black">
                            %
                          </Text>
                        }
                        rightSectionWidth={40}
                        onChange={(val) => handleChangeTax("bm", val)}
                        error={
                          validationForm.bm.isError
                            ? `${validationForm.bm.message}`
                            : ""
                        }
                        thousandSeparator=","
                        size="xs"
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label="PPH"
                        placeholder="Input pph"
                        value={formTaxes.pph}
                        rightSection={
                          <Text fz={12} c="black">
                            %
                          </Text>
                        }
                        rightSectionWidth={40}
                        onChange={(val) => handleChangeTax("pph", val)}
                        error={
                          validationForm.pph.isError
                            ? `${validationForm.pph.message}`
                            : ""
                        }
                        thousandSeparator=","
                        size="xs"
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label="PPN"
                        placeholder="Input ppn"
                        value={formTaxes.ppn}
                        rightSection={
                          <Text fz={12} c="black">
                            %
                          </Text>
                        }
                        rightSectionWidth={40}
                        onChange={(val) => handleChangeTax("ppn", val)}
                        error={
                          validationForm.ppn.isError
                            ? `${validationForm.ppn.message}`
                            : ""
                        }
                        thousandSeparator=","
                        size="xs"
                        withAsterisk
                      />
                    </Box>
                  </SimpleGrid>
                </Box>
              </ScrollArea>
            </Tabs.Panel>
            <Tabs.Panel value="variant">
              <ScrollArea
                h={500}
                type="scroll"
                offsetScrollbars
                scrollbarSize={4}
                py={20}
              >
                <Box>
                  <Paper
                    shadow="sm"
                    radius="md"
                    withBorder
                    p="md"
                    mx={10}
                    mb="md"
                  >
                    <Switch
                      checked={useVariant}
                      onChange={(event) =>
                        setUseVariant(event.currentTarget.checked)
                      }
                      label="Enable Variant"
                      size="xs"
                    />
                  </Paper>
                  <Box mx={12}>{mappingFormVariant(useVariant)}</Box>
                </Box>
              </ScrollArea>
            </Tabs.Panel>
          </Tabs>
        </Box>
        <Box mt={20}>
          <Flex justify="flex-end">
            <Group>
              <Button size="xs" variant="outline" onClick={onCloseModal}>
                Close
              </Button>
              <Button
                size="xs"
                loading={loadingForm}
                variant="filled"
                onClick={() => submitUpdateOrderItem(formData, formTaxes)}
              >
                Update
              </Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    );
  };

  return <Box>{loadForm()}</Box>;
};

export default FormAdjustOrderProduct;
